// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3ZNPu","balanceDisclaimer":"posDashboard_balanceDisclaimer__2jnRJ"};